<div *ngIf="firstCommunity" style="background-color: #EEF5F9; min-height: 98vh;">
    <div class="lobby-header d-flex-between" (click)="navigateToPage('mimenu')">
        <div class="d-flex aling-items-center">
            <div>
                <!-- <img src="assets/images/menucontexto.png" width="70" height="18"> -->
            </div>
        </div>
        <div class="btn-givis d-flex aling-items-center" (click)="navigateToPage('givis')">
            <img src="assets/images/billetera.png" class="mr-2" width="18">
            <div class="font-12 font-bold">Mis Givis</div>
        </div>
    </div>
    <div class="p-20" style="padding-top: 60px !important;">
        <!-- Country select -->
        <div class="d-flex-center align-items-center">
            <img *ngIf="selectedCountry" [src]="selectedCountry.img" class="country-flag" alt="{{ selectedCountry.name }}" />
            <div class="font-14 font-bold text-center">
                Estás Viendo Givi            
            </div>
            <div class="country-select">
                <div class="selected-country" (click)="toggleDropdown()">
                    <span class="font-14 font-bold ml-2 text-primary">{{ selectedCountry ? selectedCountry.name : 'Seleccionar País' }}</span>
                    <i class="mdi mdi-chevron-down" style="font-size: 24px;"></i>
                </div>
                <div class="dropdown" *ngIf="dropdownOpen">
                    <div 
                        class="dropdown-option" 
                        *ngFor="let country of countries" 
                        (click)="selectCountry(country)">
                        <img [src]="country.img" class="country-flag" alt="{{ country.name }}" />
                        <span>{{ country.name }}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Main Info -->
        <div class="info-box p-20 m-t-10" (click)="onDetailsOrJoin(firstCommunity.id)">
            <div class="d-flex-between align-items-center">
                <div>
                    <div class="font-16 font-bold">{{firstCommunity.name}}</div>
                    <div class="font-14">Experiencias gastronómicas únicas.</div>
                </div>
                <div style="background-color: #000; padding: 5px 10px; border-radius: 10px;">
                    <i class="mdi mdi-chevron-right" style="font-size: 24px; color: #fff;"></i>
                </div>
            </div>
            <div class="m-t-20">
                <img [src]="firstCommunity.bannerUrl" style="width: 100%; border-radius: 15px;">
            </div>
            <div class="m-t-20">
                <div class="font-14 text-center">¡Prepárate para disfrutar todo el año!</div>
                <div class="font-12 text-center m-t-10">{{firstCommunity.description}}</div>
            </div>
            <div class="m-t-20 d-flex-center">
                <img [src]="firstCommunity.imageUrl" style="max-width: 100%;">
            </div>
        </div>
    </div>
    <!-- Givis -->
    <div class="p-20" style="background-color: #fff; box-shadow: 0px -6px 6px -3px rgba(32, 32, 32, 0.2);">
        <div class="info-box p-10" style="position: relative;" (click)="navigateToPage('givis')">
            <div class="d-flex align-items-center">
                <div style="background-color: #EBF3FF; border-radius: 50%; padding: 15px;">
                    <img src="assets/images/MisGivis.png" width="35">
                </div>
                <div class="ml-3">
                    <div class="font-16 font-bold">
                        Mis Givis
                    </div>
                    <div class="font-14">
                        ¡Accede de manera rápida y sencilla a todos tus beneficios!
                    </div>
                </div>
            </div>
            <div class="btn-go">
                <i class="mdi mdi-chevron-right" style="font-size: 24px; color: #fff;"></i>
            </div>
        </div>
    </div>
</div>
